import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ResponseType  {
    _originalTypeClassName = "zERP.BO.ResponseType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ResponseType.translate = translateService;
}
this.Errors = [];
this.Id = null;
this.Index = null;
this.InvoiceUid = null;
this.InvoiceMark = null;
this.ClassificationMark = null;
this.CancellationMark = null;
this.AuthenticationCode = null;
this.StatusCode = null;
this.QrUrl = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Index:any;
InvoiceUid:any;
InvoiceMark:any;
ClassificationMark:any;
CancellationMark:any;
AuthenticationCode:any;
StatusCode:any;
QrUrl:any;
Errors:any;
static setErrors = ($this, items) => {
                if (items == null) items = [];
                if ($this.Errors == null) $this.Errors = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Errors.length > 0) {
                    Domain.ResponseType.removeErrors($this, $this.Errors[0]);
                }

                Domain.ResponseType.addManyErrors($this, copyItems);
            }
static addManyErrors = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ResponseType.addErrors($this, items[i]);
                }
            }
static addErrors = ($this, item) => {
                if ($this.Errors == null) $this.Errors = [];
                if (item == null || $this.Errors.indexOf(item) > -1) return;
                $this.Errors.push(item);
}
static addRangeErrors = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ResponseType.addErrors($this, item));
            }
static removeErrors = ($this, item) => {
                if ($this == null || $this.Errors == null || $this.Errors.indexOf(item) === -1) return;
                var _index = $this.Errors.indexOf(item);
                $this.Errors.splice(_index, 1);
}
static clearErrors = ($this) => { $this.Errors = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}